import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';
import PendingActionView from './PendingAction.view';

const ACTIONABLE_SUBHEAD_BY_ROLE = {
  super_admin:            'Everything awaiting action, across all entities.',
  supervisor:             'Assigned to you, unassigned intake, and dept-confirmed replies.',
  dept_manager:           "Your department's open tickets and prior reopens.",
  dept_manager_finance:   "Finance-gated refunds and your department's open tickets.",
  agent:                  'Assigned to you, and reopens you last handled.',
  agent_finance:          'Finance-gated refunds and tickets assigned to you.',
};

function getActionableSubhead(user) {
  if (!user) return '';
  const isFinance = (user.department || '').toLowerCase() === 'finance';
  if (user.role === 'super_admin') return ACTIONABLE_SUBHEAD_BY_ROLE.super_admin;
  if (['entity_manager', 'cs_supervisor'].includes(user.role)) return ACTIONABLE_SUBHEAD_BY_ROLE.supervisor;
  if (user.role === 'dept_manager') {
    return isFinance ? ACTIONABLE_SUBHEAD_BY_ROLE.dept_manager_finance : ACTIONABLE_SUBHEAD_BY_ROLE.dept_manager;
  }
  return isFinance ? ACTIONABLE_SUBHEAD_BY_ROLE.agent_finance : ACTIONABLE_SUBHEAD_BY_ROLE.agent;
}

export default function PendingAction() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState({ actionable: [], team: [], actionableCount: 0 });
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get('/tickets/pending-action');
      setData({
        actionable: Array.isArray(res.data?.actionable) ? res.data.actionable : [],
        team:       Array.isArray(res.data?.team) ? res.data.team : [],
        actionableCount: res.data?.actionableCount || 0,
      });
    } catch (err) {
      // Fail-soft: empty sections, never crash.
      console.error('pending-action load error:', err);
      setData({ actionable: [], team: [], actionableCount: 0 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const showClosedLink = user?.role === 'dept_manager' || user?.role === 'dept_user';

  return (
    <PendingActionView
      actionable={data.actionable}
      team={data.team}
      actionableSubhead={getActionableSubhead(user)}
      showClosedLink={showClosedLink}
      loading={loading}
      onReload={load}
      onRowClick={(id) => navigate(`/tickets/${id}`)}
    />
  );
}
